<div class="p-col-12 ui-md-12">
    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_MSG' | translate}}</h2>
    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>
</div>
<app-authentication-passwordreset [backButtonVisible]="false"
    (resetPasswordClicked)="onResetPasswordClick($event)"></app-authentication-passwordreset>